<template>
	<div class="horse-placeholder">
		<div class="horse-placeholder__content">
			<div class="horse">
				🐎
			</div>
			{{placeholder}}
		</div>
	</div>
</template>

<script>
	export default {
		name: "horse-placeholder",
		props:{
			placeholder:{
				type: String,
				default: 'Please select stream'
			}
		}
	}
</script>

<style lang="scss">
	@font-face {
		font-family: Muybridge;
		src: url("../fonts/MuybridgeGX.woff2");
	}

	@keyframes Gallop {
		from { font-variation-settings: "TIME" 0; }
		to { font-variation-settings: "TIME" 1000; }
	}

	.horse-placeholder {
		width: 100%;
		padding-top: 56.25%;
		position: relative;

		&__content{
			position: absolute;
			width: 100%;
			height: 100%;
			left: 0;
			top: 0;

			color: #fff;
			font-size: 32px;
			background-color: #000;

			text-align: center;

			.horse{
				color: rgb(0, 105, 44);
				//filter: blur(1px);
				font: 320px Muybridge;
				animation:  0.7s linear infinite Gallop;

				@media (max-width: 1024px) {
					font-size: 100px;
				}
			}
		}
	}
</style>